import React, { forwardRef } from 'react';

const Input = forwardRef(({ name, onChange, type = "text", defaultValue = null, disabled = false }, ref) => {
    return <input className="input" id={name} type={type} name={name} ref={ref} onChange={onChange} disabled={disabled} {...defaultValue && { defaultValue: defaultValue }} />
});

export default Input;